import { useEffect, useState } from 'preact/hooks';
import { getFilters } from '../../lib/api';
import FilterBox from './filters/FilterBox';
import FilterPopup from './FilterPopup';
import IndustryFilter from './filters/IndustryFilter';
import CountyFilter from './filters/CountyFilter';
import TypeFilter from './filters/TypeFilter';
import SpeciesFilter from './filters/SpeciesFilter';
import PastSearches from './filters/PastSearches';

export default function Filters({ filters, setFilters }) {
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [popupView, setPopupView] = useState('main');

	const [filterData, setFilterData] = useState(null);
	const [loading, setLoading] = useState(false);

	const [industriesSearchInput, setIndustriesSearchInput] = useState('');

	useEffect(() => {
		getData();
	}, [industriesSearchInput]);

	async function getData() {
		setLoading(true);
		const data = await getFilters(industriesSearchInput);
		setFilterData(data);
		setLoading(false);
	}

	return (
		<>
			<div class="w-3/12 pr-16 flex-col gap-y-8 hidden lg:flex relative">
				<TypeFilter filters={filters} setFilters={setFilters} />
				<FilterBox title="Næring" icon="industry-alt">
					<IndustryFilter
						industries={filterData?.industries?.nodes}
						industriesSearchInput={industriesSearchInput}
						setIndustriesSearchInput={setIndustriesSearchInput}
						filters={filters}
						setFilters={setFilters}
					/>
				</FilterBox>
				<FilterBox title="Arter" icon="fish">
					<SpeciesFilter
						species={filterData?.species?.nodes}
						filters={filters}
						setFilters={setFilters}
					/>
				</FilterBox>
				<FilterBox title="Fylke" icon="map-marker-alt">
					<CountyFilter
						counties={filterData?.counties?.nodes}
						filters={filters}
						setFilters={setFilters}
					/>
				</FilterBox>
				<PastSearches filters={filters} setFilters={setFilters} />
				{loading && (
					<div class="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50"></div>
				)}
			</div>

			<button
				onClick={() => setIsPopupOpen(true)}
				class="rounded-lg bg-yellow text-base font-bold px-7 py-3.5 fixed bottom-4 left-1/2 transform -translate-x-1/2 lg:hidden z-40 whitespace-nowrap"
			>
				Åpne filtre <i class="far fa-filter ml-1"></i>
			</button>

			{isPopupOpen && (
				<FilterPopup
					title="Filtre"
					setIsPopupOpen={setIsPopupOpen}
					popupView={popupView}
					setPopupView={setPopupView}
					filterData={filterData}
					filters={filters}
					setFilters={setFilters}
				/>
			)}
		</>
	);
}
